import * as React from 'react'
import { useState, useEffect, useRef, useMemo, forwardRef, useImperativeHandle } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useSelector } from 'react-redux'
import {
  Divider, IconButton, Select, Typography, FormControl, InputLabel, MenuItem, Grid, scopedCssBaselineClasses, Container, TableContainer, Paper,
  FormControlLabel,
  Checkbox, Popper, Popover,
} from '@mui/material'
import { findCode, printVariable, truncate, forceNumber } from '@util/helper'
import { useMediaQuery } from '@mui/material'
import WebService from '@util/webService'
import useSnackbar from '@hooks/useSnackbar'
import useIndicator from '@hooks/useIndicator'
import axios from 'axios'
import { Fragment } from 'react'
import moment from 'moment'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
import MyTableHead from '@components/MyTableHead'
import ConfirmDialog from '@components/ConfirmDialog'
import useAlert from '@hooks/useAlert'
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined'
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined'
import SendOutlinedIcon from '@mui/icons-material/SendOutlined'
import Box from '@mui/material/Box'
import { GlobalStyle as gs } from '@src/GlobalStyle'
import '@scss/App.scss'
import CloseIcon from '@mui/icons-material/Close'
import { useTheme } from '@mui/material/styles';
import { comma } from '@util/helper'
import { styled } from '@mui/material/styles';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined';
import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined';
import FlatButton from '@components/FlatButton'
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import MinimizeIcon from '@mui/icons-material/Minimize';
import * as ExcelJS from 'exceljs'
import ExcelExporter from '@components/ExcelExporter'
import Draggable from 'react-draggable'
import { flushSync } from 'react-dom'
import PriceEditor from '@components/PriceEditor'
import { ContactlessOutlined } from '@mui/icons-material'

const mybox = {
  // 공통 기본 스타일 (폰트, 정렬 등)
  base: { fontSize: '13px', color: '#333', pr: 1, textAlign: 'right', boxSizing: 'border-box' },

  top: {
    display: 'flex',
    height: 65,
    alignItems: 'center',
    // borderBottom: '1px solid #eee',
    backgroundColor: '#f8f9fa'
  },
  bottom: {
    display: 'none',
    height: 34,
    alignItems: 'center',
    backgroundColor: '#fff',
  },

  // 필드별 개별 sx (너비와 특수 스타일)
  grade: { width: 60, textAlign: 'center' },
  className: { width: 70, textAlign: 'center' },
  classNum: { width: 70, textAlign: 'center' },
  name: { width: 100, textAlign: 'center' },

  budget: { width: 100 },
  amtRemain: { width: 100 },
  amtUsed: { width: 100 },
  amtBill: { width: 100 },

  // 하단 세부 항목용 (일괄 50px)
  fees: { width: 100, fontSize: '12px', color: '#666' },

  sublabel: { width: 100, pl: 2, fontSize: '11px', color: '#999', textAlign: 'left' },
};

const StickyTableCell = styled(TableCell)(({ theme }) => ({
  position: 'sticky !important', // 브라우저 우선순위 강제
  backgroundColor: '#ffffff',     // 투명하면 뒤에 글자가 보임
  zIndex: 10,
  borderRight: '1px solid #e0e0e0',
  padding: '4px 8px',
  boxSizing: 'border-box',
}));

const TOTAL_STICKY_WIDTH = 500
const thingCodes = ['S004', 'S005', 'S006']
const serviceCodes = ['S002', 'S003', 'S007']

const xxx = async (planId, schoolId) => {

  const url = `/voucher/attdnc/count/${planId}/${schoolId}`
  const resp = await WebService.post(url)
  return resp
}

const calcAmtFin = (wallet, lectures, oldBaskets) => {
  lectures.sort((a, b) => a.title.localeCompare(b.title))
  const baskets = [...oldBaskets]

  if (wallet.amtBill > 0) {

    const totalThingAmt = lectures.reduce((sum, l) => {
      const lectureBaskets = baskets.filter(r => r.lectureId === l.id && thingCodes.includes(r.feeCode))
      return sum + lectureBaskets.reduce((acc, cur) => acc + Number(cur.amt || 0), 0)
    }, 0)

    const thingCost = Math.max(totalThingAmt - wallet.amtUsed, 0)
    const serviceCost = wallet.amtBill - thingCost
    console.log('thingCost=>', thingCost)
    console.log('serviceCost=>', serviceCost)

    const totalServiceAmt = lectures.reduce((sum, l) => {
      const lectureBaskets = baskets.filter(r => r.lectureId === l.id && serviceCodes.includes(r.feeCode))
      return sum + lectureBaskets.reduce((acc, cur) => acc + Number(cur.amt || 0), 0)
    }, 0) || 1

    // 고재비 등 할 당
    if (thingCost > 0) {
      let cursorCost = thingCost
      for (const lecture of lectures) {
        if (cursorCost <= 0) break // 이미 다 썼으면 전체 루프 종료

        const lectureBaskets = baskets.filter(r => r.lectureId === lecture.id)
        const targets = lectureBaskets.filter(r => thingCodes.includes(r.feeCode))

        for (const basket of targets) {
          if (cursorCost <= 0) break // 개별 항목 처리 중 소진 시 중단

          // basket.amt(한도)와 남은 cursorCost 중 작은 값을 할당
          const amtFin = Math.min(Number(basket.amt || 0), cursorCost)
          basket.amtFin = amtFin
          cursorCost -= amtFin
        }
      }
      if (cursorCost > 0) {
        alert(`교재비, 재로비의 남은 금액 ${cursorCost} 을 할 당 할 수 없어 계산을 중단합니다.`)
        return
      }
    }

    if (serviceCost > 0) {
      let cursorCost = serviceCost
      for (const lecture of lectures) {
        if (cursorCost <= 0) break // 이미 다 썼으면 전체 루프 종료

        const lectureBaskets = baskets.filter(r => r.lectureId === lecture.id)
        const targets = lectureBaskets.filter(r => serviceCodes.includes(r.feeCode))

        for (const basket of targets) {
          if (cursorCost <= 0) break // 개별 항목 처리 중 소진 시 중단

          // basket.amt(한도)와 남은 cursorCost 중 작은 값을 할당
          const amtFin = Math.min(Number(basket.amt || 0), cursorCost)
          basket.amtFin = amtFin
          cursorCost -= amtFin
        }
      }
      if (cursorCost > 0) {
        alert(`교재비, 재로비의 남은 금액 ${cursorCost} 을 할 당 할 수 없어 계산을 중단합니다.`)
        return
      }
    }


    return baskets
  }
}

const calcAmtFin2 = (wallet, lectures, oldBaskets) => {
  const baskets = [...oldBaskets]

  if (wallet.amtBill > 0) {



    const totalThingAmt = lectures.reduce((sum, l) => {
      const lectureBaskets = baskets.filter(r => r.lectureId === l.id && thingCodes.includes(r.feeCode))
      return sum + lectureBaskets.reduce((acc, cur) => acc + Number(cur.amt || 0), 0)
    }, 0)

    const thingCost = Math.max(totalThingAmt - wallet.amtUsed, 0)
    const serviceCost = wallet.amtBill - thingCost
    console.log('thingCost=>', thingCost)
    console.log('serviceCost=>', serviceCost)

    const totalServiceAmt = lectures.reduce((sum, l) => {
      const lectureBaskets = baskets.filter(r => r.lectureId === l.id && serviceCodes.includes(r.feeCode))
      return sum + lectureBaskets.reduce((acc, cur) => acc + Number(cur.amt || 0), 0)
    }, 0) || 1

    // 고재비 등 할 당
    if (thingCost > 0) {
      let cursorCost = thingCost
      for (const lecture of lectures) {
        if (cursorCost <= 0) break // 이미 다 썼으면 전체 루프 종료

        const lectureBaskets = baskets.filter(r => r.lectureId === lecture.id)
        const targets = lectureBaskets.filter(r => thingCodes.includes(r.feeCode))

        for (const basket of targets) {
          if (cursorCost <= 0) break // 개별 항목 처리 중 소진 시 중단

          // basket.amt(한도)와 남은 cursorCost 중 작은 값을 할당
          const amtFin = Math.min(Number(basket.amt || 0), cursorCost)
          basket.amtFin = amtFin
          cursorCost -= amtFin
        }
      }
      if (cursorCost > 0) {
        alert(`교재비, 재로비의 남은 금액 ${cursorCost} 을 할 당 할 수 없어 계산을 중단합니다.`)
        return
      }
    }


    // 서비스 요금 할당
    lectures.forEach(lecture => {
      const lectureBaskets = baskets.filter(r => r.lectureId === lecture.id)

      const lectureSerivceAmt = lectureBaskets.filter(r => serviceCodes.includes(r.feeCode)).reduce((acc, cur) => acc + Number(cur.amt || 0), 0)
      const assignedAmtForLecture = (wallet.amtBill * lectureSerivceAmt) / totalServiceAmt

      const teacherAmt = lectureBaskets.find(r => r.feeCode === 'S002')?.amt || 0
      const marginAmt = lectureBaskets.find(r => r.feeCode === 'S003')?.amt || 0
      const bojoAmt = lectureBaskets.find(r => r.feeCode === 'S007')?.amt || 0

      const priceRatio = {
        'S002': (teacherAmt / lectureSerivceAmt),
        'S003': (marginAmt / lectureSerivceAmt),
        'S007': (bojoAmt / lectureSerivceAmt)
      }

      lectureBaskets.filter(r => serviceCodes.includes(r.feeCode)).forEach(b => {
        if (b.amt > 0) {
          b.amtFin = Math.min(b.amt, Math.floor(assignedAmtForLecture * priceRatio[b.feeCode]))
        }
      })
    })

    // 잔액 불일치 해소
    const currentTotal = baskets.filter(r => serviceCodes.includes(r.feeCode)).reduce((acc, cur) => acc + Number(cur.amtFin || 0), 0)
    // let diff = wallet.amtBill - currentTotal
    let diff = serviceCost - currentTotal

    if (diff > 0) {
      // S003 항목 중 할당 대상인 것들만 추출
      const s003Baskets = baskets.filter(r => r.feeCode === 'S003' && r.amt > 0)

      if (s003Baskets.length > 0) {
        let index = 0
        while (diff > 0) {
          // 순환하며 1씩 추가
          const target = s003Baskets[index % s003Baskets.length]
          target.amtFin = (target.amtFin || 0) + 1
          diff--
          index++
        }
      }
    }

    return baskets
    // set_baskets([...baskets])
    // const allocBill = baskets.reduce((acc, cur) => {
    //   return acc + Number(cur.amtFin)
    // }, 0)
    // set_allocBill(allocBill)
  }
}



export const handleBasketAmountChange = (params) => {
  const {
    inputVal,
    basket,
    wallet,
    student,
    maps,
    budget
  } = params;

  const studentBaskets = maps.basketsByStudent[student.id] || []

  const totalPureBefore = studentBaskets.reduce((acc, b) => acc + (Number(b.amt) || 0), 0)

  basket.amt = inputVal

};

const FinEditor = ({ voucherInfo, feeCodes, id, onUpdateAmtFin }) => {
  const [open, set_open] = useState(false)
  const ref = useRef(null)
  const [wallet, set_wallet] = useState({})
  const [student, set_student] = useState({})
  const [lectures, set_lectures] = useState([])
  const [baskets, set_baskets] = useState([])
  const [allocBill, set_allocBill] = useState(0)
  const [needBill, set_needBill] = useState(0)
  const [counter, set_counter] = useState(0)

  const voucherInfoRef = useRef(voucherInfo)


  const isPlanAlive = () => {
    if (!wallet?.id) {
      return false
    }
    const plan = voucherInfoRef.current?.maps?.planMap[wallet.planId]

    if (plan?.closeYn === 'Y' || plan?.activeYn === 'N') {
      return false
    }
    return true
  }
  const canEdit = (basket) => {

    if (!isPlanAlive()) {
      return false
    }

    if (!basket) {
      return false
    }
    // if (needBill === 0) {
    //   return false
    // }
    return true
  }

  useEffect(() => {
    const handler = (e) => {

      const w = e.detail.value
      if (w.id) {
        const lectures = voucherInfo?.maps?.lecturesByWallet[w.id]
        const baskets = voucherInfo?.maps?.basketsByWallet[w.id]
        const allocBill = baskets.reduce((acc, cur) => {
          return acc + Number(cur.amtFin)
        }, 0)

        set_needBill(w.amtBill)
        set_allocBill(allocBill)
        set_lectures(lectures)
        set_baskets(JSON.parse(JSON.stringify(baskets)))
        set_wallet(w)
        set_student({})
        set_counter(prev => prev + 1)
      }
    }
    if (id) {
      window.addEventListener(`update-wallet-${id}`, handler)
      return () => window.removeEventListener(`update-wallet-${id}`, handler)
    }

  }, [voucherInfo, voucherInfo.plans, id])

  useEffect(() => {
    const handler = (e) => {

      const student = e.detail.value
      if (student.id) {
        const lectures = voucherInfo?.maps?.lecturesByStudent[student.id]
        const multiLectures = voucherInfo?.maps?.multiLecturesByStudent[student.id]
        feeCodes.forEach(fc => {

        })
        const baskets = voucherInfo?.maps?.basketsByStudent[student.id]
        const allocBill = baskets.reduce((acc, cur) => {
          return acc + Number(cur.amtFin)
        }, 0)
        const wallets = voucherInfo?.maps?.walletsByStudent[student.id]

        set_needBill(student.totalAmtBill)
        set_allocBill(allocBill)
        set_lectures(lectures)
        set_baskets(JSON.parse(JSON.stringify(baskets)))
        set_wallet({})
        set_student(student)
        set_counter(prev => prev + 1)
      }
    }
    if (id) {
      window.addEventListener(`update-student-${id}`, handler)
      return () => window.removeEventListener(`update-student-${id}`, handler)
    }

  }, [voucherInfo, voucherInfo.plans, id])

  useEffect(() => {
    voucherInfoRef.current = voucherInfo
  }, [voucherInfo])

  const dataExists = wallet?.id || student?.id
  if (!dataExists) return null

  return (
    <Draggable
      handle=".drag-handle"
      cancel="input, textarea, button, select, option"
      bounds={{
        top: -window.innerHeight + 120, // 위로는 화면 끝까지 (헤더 여유분 제외)
        bottom: 0,                      // 초기 위치(바닥) 아래로는 못 내려감
        left: 0,                        // 초기 위치(왼쪽 끝) 왼쪽으로는 못 나감
        right: window.innerWidth - 420  // 오른쪽으로는 화면 끝까지 (창 너비 제외)
      }}
      enableUserSelectHack={false}
    >
      <Paper
        elevation={8}
        sx={{
          position: 'fixed',
          bottom: 0,         // 바닥에 딱 붙여야 bounds 계산이 정확함
          left: 24,          // 왼쪽에서 24px 띄움
          width: 700,
          zIndex: 2000, // 최상단 유지
          borderRadius: '8px 8px 0 0',
          border: '1px solid #dadce0',
          // display: editPlan ? 'flex' : 'none',
          flexDirection: 'column',
          bgcolor: 'background.paper'
        }}
      >
        <Box
          className="drag-handle"
          sx={{
            bgcolor: '#404040',
            color: 'white',
            p: 1.5,
            display: 'flex',
            justifyContent: 'space-between',
            borderRadius: '8px 8px 0 0',
            cursor: 'move'
          }}
        >
          <Typography>징수 금액 조정</Typography>
          <CloseIcon
            fontSize="small"
            sx={{ cursor: 'pointer' }}
            onClick={() => {
              set_wallet({})
              set_student({})
              set_lectures([])
              set_baskets([])
            }}
          />
        </Box>

        {/* 금액 입력 영역 */}
        <Box sx={{ p: 3 }} key={counter}>
          <Box>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={6}>
                    <Grid container>
                      <Grid item xs={12}>
                        <Grid container>
                          <Grid item xs={6}>
                            <Typography >필요 징수액: </Typography>
                          </Grid>
                          <Grid item>
                            <Typography> {comma(needBill)}</Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        <Grid container>
                          <Grid item xs={6}>
                            <Typography>보호자 징수액:</Typography>
                          </Grid>
                          <Grid item>
                            <Typography> {comma(allocBill)}</Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {
                      wallet?.id ? (
                        <Button
                          disabled={!isPlanAlive()}
                          onClick={() => {
                            const newBaskets = calcAmtFin(wallet, lectures, baskets)
                            if (newBaskets) {
                              set_baskets(newBaskets)
                              const allocBill = newBaskets.reduce((acc, cur) => {
                                return acc + Number(cur.amtFin)
                              }, 0)
                              set_allocBill(allocBill)
                            }
                          }}
                        >
                          징수금 할당
                        </Button>
                      ) : null
                    }

                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                {
                  needBill !== allocBill ? (
                    <>
                      <Typography color='error'>필요 징수액과 보호자 징수액이 일치하지 않습니다.</Typography>
                      {
                        student.id ? (
                          <Typography color='error'>징수액은 각 차수에서 활성화 후 수정 가능합니다.</Typography>
                        ) : (
                          null
                        )
                      }
                    </>

                  ) : <Typography>금액이 일치합니다.</Typography>
                }
              </Grid>


              <Grid item xs={12}>
                <Divider />
              </Grid>
            </Grid>

            <table style={{ marginTop: 5 }} >
              <thead>
                <tr>
                  <th style={{ width: 150 }}>강좌명</th>
                  {
                    feeCodes.map((fc, idx) => (
                      <th>{fc.name}</th>
                    ))
                  }
                </tr>

              </thead>
              <tbody>
                {
                  lectures.sort((a, b) => a.title.localeCompare(b.title)).map((lecture, idx) => (
                    <tr>
                      <td style={{ width: 150 }}>{lecture.title}</td>
                      {
                        feeCodes.map((fc, idx2) => (
                          (() => {
                            const basket = baskets.find(b => b.lectureId === lecture.id && b.feeCode === fc.code)
                            const amtFin = baskets.filter(b => b.lectureId === lecture.id && b.feeCode === fc.code).map(b => b?.amtFin).reduce((acc, cur) => acc + Number(cur), 0) || 0
                            if (basket && student.id) {
                              basket.amtFin = amtFin
                            }

                            return (
                              <td>
                                <TextField
                                  size="small"
                                  disabled={!canEdit(basket)}
                                  // defaultValue={basket?.amtFin}
                                  value={basket?.amtFin}
                                  sx={{
                                    width: '100%',
                                    // 폰트 크기 조절 (기본은 보통 16px나 14px임)
                                    '& .MuiInputBase-input': {
                                      fontSize: '0.9em',      // 폰트 크기 축소
                                      padding: '4px 6px',    // 상하좌우 여백을 줄여 전체 높이 축소
                                      textAlign: 'right'
                                    },
                                    //  외곽선(Outlined) 높이 자체를 더 줄이고 싶을 때
                                    '& .MuiOutlinedInput-root': {
                                      height: '28px',        // 전체 필드 높이 강제 지정
                                      borderRadius: '4px'
                                    },
                                    backgroundColor: !canEdit(basket) ? '#eee' : null
                                  }}
                                  onChange={(e) => {
                                    const val = forceNumber(e.target.value)
                                    e.target.value = val
                                    basket.amtFin = val
                                    const ab = baskets?.reduce((acc, cur) => {
                                      return acc + Number(cur.amtFin)
                                    }, 0)
                                    set_allocBill(ab)
                                  }}
                                />

                              </td>
                            )
                          })()
                        ))
                      }

                    </tr>

                  ))
                }
              </tbody>
            </table>
            {
              wallet?.id ? (
                <Grid container spacing={1} style={{ marginTop: 10 }}>
                  <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      disabled={needBill !== allocBill || !isPlanAlive()}
                      variant={'contained'}
                      onClick={() => {
                        onUpdateAmtFin(baskets)
                      }}
                    >
                      저장
                    </Button>
                  </Grid>
                </Grid>
              ) : null
            }

          </Box>
        </Box>
      </Paper>
    </Draggable>
  )

}


// const BillViewer = ({voucherInfo, feeCodes, lectureId, studentId}) => {
const BillViewer = forwardRef((props, ref) => {

  const { voucherInfo = {}, feeCodes = [] } = props
  const bills = voucherInfo?.bills || []
  const feesbyLecture = voucherInfo?.maps?.feesbyLecture || []
  const [open, set_open] = useState(false)
  const [anchorEl, set_anchorEl] = useState(null)
  const [pos, set_pos] = useState({ x: 0, y: 0 })
  const [billMap, set_billMap] = useState({})
  const [student, set_student] = useState({})
  const [lecture, set_lecture] = useState({})
  const [wallet, set_wallet] = useState({})
  const [servicePrice, set_servicePrice] = useState(0)
  const [oneTimePrice, set_oneTimePrice] = useState(0)
  const [planAtttdncCountMap, set_planAtttdncCountMap] = useState({})
  const [attdncCount, set_attdncCount] = useState(0)
  const nodeRef = useRef(null)
  console.log('BillViewer rendering...')
  const fetchAttdncCountMap = async (planId) => {
    if (planAtttdncCountMap[planId]) {
      return
    }

    const url = `/voucher/attdnc/count/${planId}/${voucherInfo.voucher.schoolId}`
    const resp = await WebService.get(url)
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const attdncCountMap = JSON.parse(repMessage.attdncCountMap)
    console.log('attdncCountMap=>', attdncCountMap)
    planAtttdncCountMap[planId] = attdncCountMap
    set_planAtttdncCountMap({ ...planAtttdncCountMap })
  }

  useImperativeHandle(ref, () => ({
    open: (event, lecture, student, wallet) => {
      const rect = event.currentTarget.getBoundingClientRect()
      const startX = rect.left
      const startY = rect.bottom

      set_pos({ x: startX, y: startY })
      set_anchorEl(event.currentTarget)

      const fees = feesbyLecture[lecture.id]
      let price = 0
      const billMap = {}
      fees.forEach(f => {
        const found = bills.find(r => r.studentId === student.id && r.feeId === f.id)
        if (found) {
          billMap[f.feeCode] = found
          if (serviceCodes.includes(f.feeCode)) {
            price += Number(found.pmt)
          }
        }
      })
      set_servicePrice(price)
      const lecCount = lecture.lecCount || 1
      set_oneTimePrice(Math.floor(price / lecCount))


      set_billMap(billMap)
      set_lecture(lecture)
      set_student(student)
      set_wallet(wallet)
      set_open(true)
    }
  }))

  const handleClose = () => {
    set_anchorEl(null)
  }

  useEffect(() => {
    if(wallet?.id) {
      fetchAttdncCountMap(wallet.planId)
    }
    
  }, [wallet])


  useEffect(() => {
    const cnt = planAtttdncCountMap[wallet?.planId]?.[`${wallet.id}-${lecture.id}`] || 0
    set_attdncCount(cnt)
  }, [lecture, student, wallet, planAtttdncCountMap])

  if (!open) return null

  return (
    <Box sx={{ position: 'fixed', top: 0, left: 0, zIndex: 1300 }}>
      <Draggable
        nodeRef={nodeRef}
        handle=".drag-handle"
        position={null} 
        defaultPosition={{ x: pos.x, y: pos.y }}
        enableUserSelectHack={false} 
        // onStart={(e) => e.stopPropagation()}
      >
        <Paper ref={nodeRef}   elevation={8} sx={{ width: 300, borderRadius: 1, border: '1px solid #ddd', p: 0, overflow: 'hidden' }}>

          <Box
            className="drag-handle" 
           
            sx={{
              cursor: 'move !important', 
              bgcolor: '#f0f0f0',
              display: 'flex',
              justifyContent: 'center',
              height: 30,
              alignItems: 'center',
              width: '100%',
              position: 'relative',
              zIndex: 9999,
            }}
          >
            <Box sx={{ display: 'flex', flex: 1, justifyContent: 'center', width: '100%' }}>
              <Typography
                sx={{
                  m: 0,
                  pointerEvents: 'none',
                }}
              >
                결제정보
              </Typography>
            </Box>

            <IconButton onClick={() => {
              set_open(false)
            }}>
              <CloseIcon
                fontSize="small"
              />
            </IconButton>

          </Box>
          <Box sx={{ p: 2 }}>
            <Grid container spacing={0}>
              <Grid item xs={12}><Typography variant='caption' fontWeight='bold'>{lecture.title}</Typography></Grid>
              <Grid item xs={12}>
                <Typography variant='caption' fontWeight='bold'>{student.grade} {student.className} {student.classNum} {student.name}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <Typography variant='body2' textAlign={'center'}>수강료</Typography>
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={8}><Typography variant='caption' >수강료(강사료+수용비+보조인건비)</Typography></Grid>
                  <Grid item xs={4} ><Typography variant='caption' display='block' textAlign={'right'}>{comma(servicePrice)}</Typography></Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={6}><Typography variant='caption'>1회결제요금</Typography></Grid>
                  <Grid item xs={6}><Typography variant='caption' display='block'  textAlign={'right'}>{comma(oneTimePrice)}</Typography></Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={6}><Typography variant='caption'>수업횟수</Typography></Grid>
                  <Grid item xs={6}><Typography variant='caption' display='block'  textAlign={'right'}>{attdncCount}</Typography></Grid>
                </Grid>
              </Grid>

              
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={6}><Typography variant='caption'>차수결제요금</Typography></Grid>
                  <Grid item xs={6}><Typography variant='caption' display='block' textAlign={'right'}>{comma(oneTimePrice * attdncCount)}</Typography></Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <Typography variant='body2' textAlign={'center'}>전체요금</Typography>
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={12}>

                {
                  feeCodes.map(fc => (
                    <Grid container>
                      <Grid item xs={6}><Typography variant='caption'>{fc.name}</Typography></Grid>
                      <Grid item xs={6}>
                        <Typography display='block' variant='caption' textAlign={'right'}>
                          {comma(billMap[fc.code]?.pmt)}
                        </Typography>
                      </Grid>
                    </Grid>
                  ))
                }
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Draggable>
    </Box>
  )
})

const AutoBox = ({ id, initialValue, ...props }) => {
  const ref = useRef(null)

  useEffect(() => {
    const handler = (e) => {
      console.log(`id:${id} handling velue=>`, e.detail.value)
      if (ref.current) ref.current.innerText = comma(e.detail.value)
    }
    if (id) {
      window.addEventListener(`update-${id}`, handler)
      return () => window.removeEventListener(`update-${id}`, handler)
    }


  }, [id])

  return (
    <Box ref={ref} {...props} >{initialValue ? comma(initialValue) : 0}</Box>
  )
}

const StudentRow = ({ voucherInfo, student, feeCodes, planViews, sortedPlans, priceEditorRef, onUpdateBudget, billViewerRef }) => {
  const elRefs = useRef({})
  const [editId, set_editId] = useState(null)
  const baskets = voucherInfo.maps.basketsByStudent[student.id] || []
  const finMap = baskets.reduce((acc, cur) => {
    if (!acc[cur.feeCode]) {
      acc[cur.feeCode] = 0
    }
    acc[cur.feeCode] += cur.amtFin
    return acc
  }, {})


  return (
    <TableRow key={`student-id:${student.id}`} hover>
      <StickyTableCell
        sx={{
          left: 0,
          width: TOTAL_STICKY_WIDTH,
          p: 0,
          // zIndex: 10,
          borderRight: '1px solid #bbb',
          borderBottom: '3px solid #f0f0f0',
          height: '1px',
          // 부모인 TableRow가 hover 상태일 때 이 셀의 배경색을 변경
          '&:hover': {
            backgroundColor: 'inherit', // 또는 원하는 호버 색상 (예: '#f5f5f5')
          },
          // 만약 TableRow 자체의 hover 효과와 맞추고 싶다면 아래와 같이 작성
          '.MuiTableRow-root:hover &': {
            backgroundColor: '#f5f7f9', // MUI 기본 hover 색상과 유사하게 설정
          }
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ ...mybox.top, backgroundColor: 'transparent' }}>
            <Box sx={{ ...mybox.base, ...mybox.grade }}>{student.grade}</Box>
            <Box sx={{ ...mybox.base, ...mybox.className }}>{student.className}</Box>
            <Box sx={{ ...mybox.base, ...mybox.classNum }}>{student.classNum}</Box>
            <Box sx={{ ...mybox.base, ...mybox.name }}>{student.name} ({student.id})</Box>
            <Box sx={{
              ...mybox.base, ...mybox.budget, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', fontWeight: 'bold', cursor: 'pointer',
              '&:hover': {
                bgcolor: 'action.hover', // MUI 기본 호버 색상
                color: 'primary.main',   // 글자색을 브랜드 컬러로 변경 (선택 사항)
              }
            }}
              onClick={(e) => {
                priceEditorRef.current.open(e, student.budget, (price) => {
                  onUpdateBudget(sortedPlans, student, price)
                })
              }}
            >
              {comma(student.budget)}

            </Box>
            <AutoBox sx={{ ...mybox.base, ...mybox.budget, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', fontWeight: 'bold' }}
              initialValue={student.totalAmtRemain}
              id={`totalAmtRemain-${student.id}`}
            />
            <AutoBox sx={{ ...mybox.base, ...mybox.amtUsed, display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
              initialValue={student?.totalAmtUsed}
              id={`totalAmtUsed-${student.id}`}
            />
            <Box sx={{ ...mybox.base, ...mybox.amtBill, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', cursor: 'pointer' }}
              onClick={() => {
                window.dispatchEvent(new CustomEvent(`update-student-finEditor`, { detail: { value: student } }))
              }}
            >
              <Typography variant='body2' color={student?.totalAmtBill !== student?.totalAmtNeed ? 'error' : null} sx={{ fontWeight: 'bold' }}>
                {comma(student?.totalAmtBill)}
                {/* {comma(student?.totalAmtBill)} / {comma(student?.totalAmtNeed)}  */}
              </Typography>

            </Box>

          </Box>
          {/* <Box sx={{ ...mybox.bottom, backgroundColor: 'transparent' }}>
            <Box sx={mybox.sublabel}></Box>
            {
              feeCodes.map(fc => {

                return (
                  <Box sx={{ ...mybox.base, ...mybox.fees }}>{comma(finMap[fc.code])} </Box>
                )
              })
            }
          </Box> */}
        </Box>
      </StickyTableCell>
      {/* 차수별 상세 데이터 */}
      {
        (() => {
          // const plans = voucherInfo?.maps?.plansByStudent[student.id]
          return (
            sortedPlans?.map((plan, planIdx) => {
              const wallet = voucherInfo.maps.walletMap[`${student.id}-${plan.id}`]
              // if(!wallet) {
              //   console.log(`wallet undfined studentId:${student.id} planId:${plan.id}`)
              // }
              const isShrink = planViews[plan.id]?.shrink
              return (
                <TableCell key={`body-plan:${plan.id}`} sx={{
                  p: 0, verticalAlign: 'center',
                  height: '1px', borderRight: '1px solid #f0f0f0',
                  borderBottom: '1px solid #f0f0f0',

                }}>
                  {
                    wallet ? (
                      <Box sx={{
                        display: 'flex', minHeight: 40, alignItems: 'stretch',
                        height: '100%',
                        borderBottom: '1px solid #f0f0f0',
                      }}>

                        {/* [병합] 지원액 영역 */}
                        <AutoBox
                          sx={{
                            width: 80,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderLeft: '1px solid #f0f0f0',
                            borderRight: '1px solid #f0f0f0',
                            fontSize: '0.8rem',
                            flexShrink: 0
                          }}
                          initialValue={wallet?.amtUsed}
                          id={`amtUsed-${wallet.id}`}
                        />
                        {/* 징수액 */}
                        <AutoBox
                          sx={{
                            width: 80,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRight: '1px solid #f0f0f0',
                            fontSize: '0.8rem',
                            flexShrink: 0,
                            cursor: 'pointer',
                            fontWeight: 'bold',

                            '&:hover': {
                              bgcolor: 'action.hover', // MUI 기본 호버 색상
                              color: 'primary.main',   // 글자색을 브랜드 컬러로 변경 (선택 사항)
                            }

                          }}
                          initialValue={wallet?.amtBill ?? 0}
                          id={`amtBill-${wallet.id}`}
                          onClick={() => {
                            window.dispatchEvent(new CustomEvent(`update-wallet-finEditor`, { detail: { value: wallet } }))
                          }}
                        />
                        {/* [상세] 강좌 및 비용 리스트 영역 */}
                        {
                          !isShrink && (
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, alignItems: 'stretch' }}>
                              {
                                (() => {
                                  const lectures = voucherInfo?.maps?.lecturesByWallet[wallet.id]?.sort((a, b) => a.title.localeCompare(b.title))
                                  return (
                                    lectures?.map((lecture, idx) => {
                                      return (
                                        <Box sx={{
                                          display: 'flex',
                                          flex: 1,
                                          alignItems: 'stretch',
                                          borderBottom: idx === lectures.length - 1 ? 'none' : '1px solid #f0f0f0'
                                        }}>
                                          {/* 강좌명 (150px) */}
                                          <Typography variant='caption'
                                            sx={{
                                              width: 150,
                                              p: 1,
                                              display: 'flex',
                                              alignItems: 'center',
                                              borderRight: '1px solid #f0f0f0',
                                              flexShrink: 0,
                                              cursor: 'pointer',
                                            }}
                                            onClick={(e) => {
                                              billViewerRef.current.open(e, lecture, student, wallet)
                                            }}
                                          >
                                            {lecture.title}
                                          </Typography>

                                          {/* 비용 코드별 금액 (각 80px) */}
                                          <Box sx={{ display: 'flex' }}>
                                            {
                                              feeCodes.map(fc => {
                                                const basket = voucherInfo.maps.basketMap[`${wallet.id}-${lecture.id}-${fc.code}`]
                                                if (basket) {
                                                  const key = `bs-${basket.id}`
                                                  return (
                                                    <Box
                                                      sx={{
                                                        width: 80, p: 0.5, textAlign: 'right', display: 'flex',
                                                        alignItems: 'center', justifyContent: 'flex-end',
                                                        fontSize: '0.75rem', borderRight: '1px solid #f0f0f0', flexShrink: 0,
                                                        minHeight: '30px', cursor: 'pointer',
                                                        // backgroundColor: editing ? '#fffde7' : 'transparent' // 편집 중일 때 강조
                                                      }}
                                                      onClick={(e) => {
                                                        e.stopPropagation()
                                                        set_editId(key)
                                                      }}
                                                    >
                                                      {
                                                        editId === key && plan.activeYn === 'Y' ? (
                                                          <input
                                                            autoFocus
                                                            type="text"
                                                            style={{ width: '100%', textAlign: 'right', border: '1px solid #1976d2' }}
                                                            defaultValue={basket ? basket.amt : '0'}
                                                            ref={(el) => elRefs.current[`basket-${key}`] = el}
                                                            onChange={(e) => {
                                                              const targetEl = elRefs.current[`basket-${key}`]
                                                              const val = forceNumber(e.target.value)
                                                              e.target.value = val
                                                            }}

                                                            onBlur={(e) => {
                                                              handleBasketAmountChange({
                                                                inputVal: e.target.value,
                                                                basket: basket,
                                                                wallet: wallet,
                                                                student: student,
                                                                maps: voucherInfo.maps,
                                                                budget: voucherInfo.budget
                                                              })
                                                              set_editId(null)
                                                            }}
                                                            onKeyDown={(e) => { if (e.key === 'Enter') e.target.blur(); }}
                                                          />
                                                        ) : (
                                                          <AutoBox
                                                            id={key}
                                                            initialValue={basket.amt}
                                                            component="span"
                                                            sx={{ cursor: 'pointer' }}
                                                          />
                                                        )
                                                      }
                                                    </Box>
                                                  )
                                                }
                                                else {
                                                  return (
                                                    <Box
                                                      sx={{
                                                        width: 80, p: 0.5, textAlign: 'right', display: 'flex',
                                                        alignItems: 'center', justifyContent: 'flex-end',
                                                        fontSize: '0.75rem', borderRight: '1px solid #f0f0f0', flexShrink: 0,
                                                        minHeight: '30px', cursor: 'pointer',
                                                        // backgroundColor: editing ? '#fffde7' : 'transparent' // 편집 중일 때 강조
                                                      }}

                                                    />

                                                  )
                                                }

                                              })
                                            }
                                          </Box>
                                        </Box>
                                      )

                                    })
                                  )

                                })()
                              }
                              {
                                (() => {
                                  const lectures = voucherInfo.maps?.lecturesByWallet[wallet.id]
                                  if (!lectures || lectures.length === 0) {
                                    return (
                                      <Box sx={{ height: 40, display: 'flex', alignItems: 'center', px: 2, color: '#ccc', fontSize: '0.7rem' }}>내역 없음</Box>
                                    )
                                  }
                                })()
                              }
                            </Box>
                          )
                        }

                      </Box>
                    ) : (
                      <div style={{ color: '#ccc', textAlign: 'center' }}>-</div>
                    )
                  }

                </TableCell>
              )
            })
          )

        })()

      }
    </TableRow>
  )
}

const SummaryRow = ({ voucherInfo, feeCodes, planViews, sortedPlans }) => {
  const { totalSummary, planSummary, feeSummaryByPlan, maps } = voucherInfo
  const plans = maps?.plans

  return (
    <TableRow hover>
      <StickyTableCell
        sx={{
          left: 0,
          width: TOTAL_STICKY_WIDTH,
          p: 0,
          // zIndex: 10,
          borderRight: '2px solid #bbb',

        }}
      >
        <Box sx={{ display: 'flex', minHeight: 44, alignItems: 'stretch', }}>
          <Box sx={{ width: 60, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>계</Box>
          <Box sx={{ width: 60, display: 'flex', alignItems: 'center', justifyContent: 'center', }}></Box>
          <Box sx={{ width: 60, display: 'flex', alignItems: 'center', justifyContent: 'center', }}></Box>
          <Box sx={{ width: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', }}></Box>

          <AutoBox sx={{ width: 100, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', fontWeight: 'bold' }}
            initialValue={totalSummary?.budget}
          />
          <AutoBox sx={{ width: 100, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', fontWeight: 'bold' }}
            initialValue={totalSummary?.totalAmtRemain}
          />
          <AutoBox sx={{ width: 100, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', fontWeight: 'bold' }}
            initialValue={totalSummary?.totalAmtUsed}
          />
          <AutoBox sx={{ width: 100, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', fontWeight: 'bold' }}
            initialValue={totalSummary?.totalAmtBill}
          />
        </Box>
      </StickyTableCell>
      {/* 차수별 상세 데이터 */}
      {
        (() => {
          // const plans = voucherInfo?.maps?.plansByStudent[student.id]
          return (
            sortedPlans?.map(plan => {
              const psum = planSummary[plan.id]
              const isShrink = planViews[plan.id]?.shrink
              return (
                <TableCell key={`body-plan:${plan.id}`} sx={{
                  p: 0, verticalAlign: 'top',
                  height: '1px'
                }}>
                  <Box sx={{
                    display: 'flex', minHeight: 40, alignItems: 'stretch',
                    height: '100%',
                  }}>

                    {/* [병합] 지원액 영역 */}
                    <AutoBox
                      sx={{
                        width: 80,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderLeft: '1px solid #f0f0f0',
                        borderRight: '1px solid #f0f0f0',
                        fontSize: '0.8rem',
                        flexShrink: 0,
                        fontWeight: 'bold'
                      }}
                      initialValue={psum.amtUsed}
                    />
                    {/* 징수액 */}
                    <AutoBox
                      sx={{
                        width: 80,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRight: '1px solid #f0f0f0',
                        fontSize: '0.8rem',
                        flexShrink: 0,
                        fontWeight: 'bold'
                      }}
                      initialValue={psum.amtBill}
                    />
                    {/* [상세] 강좌 및 비용 리스트 영역 */}
                    {
                      !isShrink && (
                        <Box sx={{ display: 'flex', flex: 1, alignItems: 'center' }}>
                          <Box sx={{
                            display: 'flex',
                            alignItems: 'stretch',
                          }}>
                            {/* 강좌명 (150px) */}
                            <Typography variant='caption' sx={{
                              width: 150,
                              p: 1,
                              display: 'flex',
                              alignItems: 'center',
                              borderRight: '1px solid #f0f0f0',
                              lineHeight: 1.2,
                              flexShrink: 0
                            }}>
                            </Typography>

                            {/* 비용 코드별 금액 (각 80px) */}
                            <Box sx={{ display: 'flex' }}>
                              {
                                feeCodes.map(fc => {
                                  const fsum = feeSummaryByPlan[plan.id][fc.code]
                                  return (
                                    <Box
                                      sx={{
                                        width: 80, p: 0.5, textAlign: 'right', display: 'flex',
                                        alignItems: 'center', justifyContent: 'flex-end',
                                        fontSize: '0.75rem', borderRight: '1px solid #f0f0f0', flexShrink: 0,
                                        minHeight: '30px', cursor: 'pointer',
                                        // backgroundColor: editing ? '#fffde7' : 'transparent' // 편집 중일 때 강조
                                      }}
                                    >
                                      <AutoBox
                                        component="span"
                                        sx={{ fontWeight: 'bold' }}
                                        initialValue={fsum}
                                      />
                                    </Box>
                                  )
                                })
                              }
                            </Box>
                          </Box>
                          {/* 남은 공간을 채워주는 더미 Box */}
                          <Box sx={{ flexGrow: 1, backgroundColor: '#fff' }} />
                        </Box>
                      )
                    }

                  </Box>

                </TableCell>
              )
            })
          )
        })()

      }
    </TableRow>
  )
}

const ManagerVoucherPartWall = ({ record, dialogHandler, tabValue, callback }) => {
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const { alert, renderAlert } = useAlert()
  const [voucherInfo, set_voucherInfo] = useState({})
  const detailHandler = useState(false)
  const codes = useSelector((state) => state.codeReducer)
  const feeCodes = codes.filter(r => r.codeGroupId === 'SA21')
  const schola = useSelector(state => state.scholaReducer);
  const [minWidth, set_minWidth] = useState(300)
  const [planViews, set_planViews] = useState({})
  const [counter, set_counter] = useState(0)
  const theme = useTheme()
  const priceEditorRef = React.useRef(null)
  const originRef = useRef({})
  const attdncCountRef = useRef({})
  const handleClose = (event, reason) => {
    if (reason && reason === 'backdropClick') {
      return
    } else {
      if (callback) {
        callback()
      }
      dialogHandler[1](false)
    }
  }
  const billViewerRef = useRef(null)
  console.log('ManagerVoucherPartWall rendering....')



  const handleDownload = () => {
    const workbook = new ExcelJS.Workbook()
    const { totalSummary, planSummary, feeSummaryByPlan, amtFinSummaryByPlan, amtFinSummaryByCode, maps } = voucherInfo
    const { plans, students, walletMap, lecturesByWallet, feeMap, basketMap, smstByPlan, walletsByStudent, lecturesByStudent, basketsByStudent } = maps

    plans.sort((a, b) => {
      const scoreA = (Number(a.smstId) * 10000) + Number(a.chasu)
      const scoreB = (Number(b.smstId) * 10000) + Number(b.chasu)

      return scoreA - scoreB
    })

    const exporter = new ExcelExporter(workbook, "바우처_상세")
    exporter
      .setValue('학년').nextCol()
      .setValue('반').nextCol()
      .setValue('번').nextCol()
      .setValue('이름').nextCol()
      .setValue('바우처액').nextCol()
      .setValue('잔액').nextCol()
      .setValue('총지원액').nextCol()
      .setValue('총징수액').nextCol()
      .setValue('강좌명').setColWidth(30).nextCol()
      .jumpTo(1, exporter.cellnum)
      .setValue('총징수액 상세')
      .nextRow()
    feeCodes.forEach(f => {
      exporter.setValue(`${f.name}`).nextCol()
    })
    exporter.jumpTo(1, exporter.cellnum)
    
    plans.forEach((plan) => {
      const smst = smstByPlan[plan.id]
      exporter
        .jumpTo(1, exporter.cellnum)
        .setValue(`${plan.chasu}차 (${smst?.year}/${smst?.gisu})`)
        .nextRow()
        .setValue('지원액').nextCol()
        .setValue('징수액').nextCol()
        .jumpTo(2, exporter.cellnum)
      // exporter.setValue('').nextCol()
      feeCodes.forEach(f => {
        exporter.setValue(f.name).nextCol()
      })
      feeCodes.forEach(f => {
        exporter.setValue(`${f.name} 징수액`).nextCol()
      })
      exporter.jumpTo(1, exporter.cellnum)
    })
    exporter.jumpTo(3, 1)

    students.forEach((student, stdIdx) => {
      const wallets = walletsByStudent[student.id]
      const play = planViews._everyStudent === 'Y' || (planViews._everyStudent === 'N' && wallets?.length > 0)
      if (!play) {
        return
      }

      exporter
        .setValue(student.grade).nextCol()
        .setValue(student.className).nextCol()
        .setValue(student.classNum).nextCol()
        .setValue(student.name).nextCol()
        .setValue(student.budget).setCurrencyStyle().nextCol()
        .setValue(student.totalAmtRemain).setCurrencyStyle().nextCol()
        .setValue(student.totalAmtUsed).setCurrencyStyle().nextCol()
        .setValue(student.totalAmtBill).setCurrencyStyle().nextCol()


      const planStart = exporter.cellnum
      const lectures = lecturesByStudent[student.id]?.sort((a, b) => a.title.localeCompare(b.title))
      const studentBaskets = basketsByStudent[student.id] || []
      const studentAmtFin  = studentBaskets.reduce((acc, cur) => {
        const key = `${cur.lectureId}-${cur.feeCode}`
        const value  = acc[key] || 0
        const amtFin = value + cur.amtFin
        acc[key] = amtFin
        return acc
      },{})

      lectures.forEach((lecture, lidx) => {
        
        plans.forEach((plan, planIdx) => {
          const wallet = walletMap[`${student.id}-${plan.id}`]
          if (planIdx === 0) {
            exporter.setValue(lecture.title).nextCol()
            feeCodes.forEach(f => {
              // const b = studentBaskets.filter(r => r.lectureId === lecture.id && r.feeCode === f.code)
              const key = `${lecture.id}-${f.code}`
              const value = studentAmtFin[key] || 0
              exporter.setValue(value).setCurrencyStyle().nextCol()
            })
          }

          if (lidx === 0) {
            // if(wallet) {
            //   exporter.setValue(wallet.amtUsed).setCurrencyStyle().nextCol()
            //   exporter.setValue(wallet.amtBill).setCurrencyStyle().nextCol()
            // }
            // else {
            //   exporter.nextCol().nextCol()
            // }
            
            exporter.setValue(wallet?.amtUsed ?? 0).setCurrencyStyle().nextCol()
            exporter.setValue(wallet?.amtBill ?? 0).setCurrencyStyle().nextCol()
          }
          else {
            exporter.nextCol().nextCol()
          }

          feeCodes.forEach(f => {
            const basket = basketMap[`${wallet?.id}-${lecture.id}-${f.code}`]
            if (basket) {
              exporter.setValue(basket?.amt ?? 0).setCurrencyStyle().nextCol()
            }
            else {
              exporter.setValue(0).setCurrencyStyle().nextCol()
            }
          })

          feeCodes.forEach(f => {
            const basket = basketMap[`${wallet?.id}-${lecture.id}-${f.code}`]
            if (basket) {
              exporter.setValue(basket?.amtFin ?? 0).setCurrencyStyle().nextCol()
            }
            else {
              exporter.setValue(0).setCurrencyStyle().nextCol()
            }
          })

        })
        
        exporter.jumpTo(exporter.rownum + 1, planStart)
      })

      exporter.jumpTo(exporter.rownum, 1)
      if (lectures.length == 0) {
        exporter.nextRow()
      }
    })

    exporter
      .setValue('계')
      .jumpTo(exporter.rownum, 5)
      .setValue(totalSummary.budget).setCurrencyStyle().nextCol()
      .setValue(totalSummary.totalAmtRemain).setCurrencyStyle().nextCol()
      .setValue(totalSummary.totalAmtUsed).setCurrencyStyle().nextCol()
      .setValue(totalSummary.totalAmtBill).setCurrencyStyle().nextCol()
      .nextCol()

    feeCodes.forEach(f => {
      exporter.setValue(amtFinSummaryByCode[f.code]).setCurrencyStyle().nextCol()
    })

    plans.forEach(plan => {
      const psum = planSummary[plan.id]
      exporter.setValue(psum.amtUsed).setCurrencyStyle().nextCol()
      exporter.setValue(psum.amtBill).setCurrencyStyle().nextCol()

      feeCodes.forEach(fee => {
        const sum = feeSummaryByPlan[plan.id][fee.code]
        exporter.setValue(sum).setCurrencyStyle().nextCol()
      })

      feeCodes.forEach(fee => {
        const sum = amtFinSummaryByPlan[plan.id][fee.code]
        exporter.setValue(sum).setCurrencyStyle().nextCol()
      })

    })

    workbook.xlsx.writeBuffer().then(buffer => {
      let filename = `${schola.name}_${record.name}`

      filename = filename + `.xlsx`
      const blob = new Blob([buffer], { type: 'application/octet-stream' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      a.click()
      window.URL.revokeObjectURL(url)
    })
  }

  const onReload = async () => {
    const url = `/voucher/reload/student/${record.id}/${schola.id}`
    openIndicator()
    const resp = await WebService.post(url)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    parseVoucher(resp, false, (v) => {
      originRef.current = JSON.parse(JSON.stringify(v))
    })
  }



  const onInitWallet = async () => {
    const url = `/voucher/init/wallet/${record.id}/${schola.id}`
    openIndicator()
    const resp = await WebService.post(url)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    parseVoucher(resp, false, (v) => {
      originRef.current = JSON.parse(JSON.stringify(v))
    })
    // openSnackbar('성공하였습니다.')
  }

  const onUpdateBudget = async (plans, student, budget) => {
    const wallets = voucherInfo.maps.walletsByStudent[student.id]
    const closedPlans = plans.filter(r => r.closeYn === 'Y')
    if (wallets?.length > 0 && closedPlans?.length > 0) {
      const walletPlanIds = wallets.map(r => r.planId)
      const closedPlanIds = new Set(closedPlans.map(r => r.id))
      console.log('walletPlanIds', walletPlanIds)
      console.log('closedPlanIds', closedPlanIds)

      // 강의 학기 ID 중 마감된 학기가 하나라도 있는지 확인
      const hasClosedWallet = walletPlanIds.some(id => closedPlanIds.has(id))

      if (hasClosedWallet) {
        alert('수강중(한) 강좌에 마감된 차수가 있어 수정할 수 없습니다.')
        return
      }
    }

    const voucherStudent = voucherInfo?.maps?.voucherByStudent[student.id]
    if (!voucherStudent?.id) {
      alert('바우처를 찾을 수 없습니다.')
      return
    }

    const url = `/voucher/update/budget/${voucherStudent.id}/${budget}/${schola.id}`
    openIndicator()
    const resp = await WebService.post(url)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    student.budget = budget
    voucherStudent.budget = budget
    set_voucherInfo({ ...voucherInfo })
  }


  const resetBaskets = (planId) => {
    const baskets = voucherInfo.maps.basketsByPlan[planId]
    baskets.forEach((b) => {
      b.amt = 0
      b.amtFin = 0
      // const key = `bs-${b.id}`
      // window.dispatchEvent(new CustomEvent(`update-${key}`, {detail: {value: 0 } }))
    })
    set_voucherInfo({ ...voucherInfo })
    alert('요금 초기화 후 저장버튼을 눌러야 서버에 반영 됩니다.')
  }


  const onSaveBasket = async (baskets, voucherId, planId, isSilent = false) => {
    // const baskets = voucherInfo.maps.basketsByPlan[planId]
    const url = `/voucher/save/basket/${voucherId}/${planId}/${schola.id}`
    const data = {
      baskets: JSON.stringify(baskets)
    }

    openIndicator()
    const resp = await WebService.post(url, data)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    if (isSilent) {
      const newVoucherInfo = parseVoucher(resp, true)
      const autoBaskkets = generateAutoBaskets(newVoucherInfo, planId)
      console.log('autoBaskkets=>', autoBaskkets)
      await onSaveBasket(autoBaskkets, voucherId, planId, false)
    }
    else {
      parseVoucher(resp, false, (v) => {
        originRef.current = JSON.parse(JSON.stringify(v))
        openSnackbar('저장되었습니다.')
      })

    }

  }

  const onUpdateAmtFin = async (baskets) => {
    // /update/basket/amt/fin/{voucherId}/{schoolId}

    const url = `/voucher/update/basket/amt/fin/${voucherInfo.voucher.id}/${schola.id}`
    const data = {
      baskets: JSON.stringify(baskets)
    }

    openIndicator()
    const resp = await WebService.post(url, data)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    parseVoucher(resp, false, (v) => {
      originRef.current = JSON.parse(JSON.stringify(v))
      openSnackbar('저장되었습니다.')
    })
  }

  const toggleDirection = () => {
    set_planViews(prev => ({
      ...prev,
      _direction: prev._direction === 'asc' ? 'desc' : 'asc'
    }))
  }

  const toggleEveryStudent = () => {
    set_planViews(prev => ({
      ...prev,
      _everyStudent: prev._everyStudent === 'Y' ? 'N' : 'Y'
    }))
  }

  const sortedPlans = useMemo(() => {
    if (!voucherInfo?.plans) return []

    const plans = [...voucherInfo.plans]
    const direction = planViews._direction || 'asc'

    return plans.sort((a, b) => {
      // 학기에 충분히 큰 값을 곱하고 차수를 더해 '절대 순번' 계산
      // 예: smstId(2026) * 10000 + chasu(1) = 20260001
      const scoreA = (Number(a.smstId) * 10000) + Number(a.chasu)
      const scoreB = (Number(b.smstId) * 10000) + Number(b.chasu)

      return direction === 'asc'
        ? scoreA - scoreB
        : scoreB - scoreA
    })
  }, [voucherInfo.plans, planViews._direction])

  const calcTotalSummary = (maps) => {
    const totalSummary = { budget: 0, totalAmtUsed: 0, totalAmtRemain: 0, totalAmtBill: 0 }

    Object.values(maps.studentMap).forEach((student) => {
      // 전체 합계 누적
      if (planViews._everyStudent === 'Y') {
        totalSummary.budget += (Number(student.budget) || 0)
        totalSummary.totalAmtUsed += (Number(student.totalAmtUsed) || 0)
        totalSummary.totalAmtRemain += (Number(student.totalAmtRemain) || 0)
        totalSummary.totalAmtBill += (Number(student.totalAmtBill) || 0)
      }
      else {
        const w = maps.walletsByStudent[student.id] || []
        if (w.length > 0) {
          totalSummary.budget += (Number(student.budget) || 0)
          totalSummary.totalAmtUsed += (Number(student.totalAmtUsed) || 0)
          totalSummary.totalAmtRemain += (Number(student.totalAmtRemain) || 0)
          totalSummary.totalAmtBill += (Number(student.totalAmtBill) || 0)
        }
      }

    })
    return totalSummary
  }

  const xxx = () => {
    console.log('voucherInfo?.data?=>', voucherInfo.data)
    voucherInfo?.wallets.forEach(w => {
      console.log('w=>', w)
      const baskets = voucherInfo?.maps?.basketsByWallet[w.id]
      const allocBill = baskets.reduce((acc, cur) => {
        return acc + Number(cur.amtFin)
      }, 0)

      console.log('allocBill=>', allocBill)
      if (w.amtBill !== 0) {
        console.log('accBill not 000000000000000')
        const lectures = voucherInfo?.maps?.lecturesByWallet[w.id]
        if (allocBill !== w.amtBill) {
          const newBaskets = calcAmtFin(w, lectures, baskets)
          const newValues = {}
          for (const nb of newBaskets) {
            newValues[nb.id] = nb.amtFin
          }

          baskets.forEach(b => {
            const newVal = newValues[b.id]
            if (newVal !== undefined) {
              console.log('newVal=>', newVal)
              b.amtFin = newVal
            }
          })
        }
      }
    })
    set_voucherInfo({ ...voucherInfo })
  }

  const generateAutoBaskets = (newVoucherInfo, planId) => {
    const { walletsByPlan } = newVoucherInfo.maps
    const wallets = walletsByPlan[planId]
    const allUpdatedBaskets = []

    wallets.forEach(w => {
      const baskets = newVoucherInfo?.maps?.basketsByWallet[w.id]
      const allocBill = baskets.reduce((acc, cur) => {
        return acc + Number(cur.amtFin)
      }, 0)

      if (w.amtBill !== 0) {
        const lectures = newVoucherInfo?.maps?.lecturesByWallet[w.id]
        if (allocBill !== w.amtBill) {
          const newBaskets = calcAmtFin(w, lectures, baskets)
          const newValues = {}
          for (const nb of newBaskets) {
            newValues[nb.id] = nb.amtFin
          }

          baskets.forEach(b => {
            const newVal = newValues[b.id]
            if (newVal !== undefined) {
              b.amtFin = newVal
            }
          })
        }
      }
      allUpdatedBaskets.push(...baskets)
    })
    return JSON.parse(JSON.stringify(allUpdatedBaskets))
  }

  const parseVoucher = (resp, isSilent, callback) => {

    /**
        * [Voucher Data Structure Map]
        * 1. studentMap: 학생 기본 정보 + 실시간 계산된 합계(totalAmtUsed, totalAmtRemain)
        * 2. basketsByStudent: 특정 학생의 전 차수 장바구니 리스트 (합계 계산용 원천 데이터)
        * 3. lecturesByWallet: 특정 지갑(Wallet)에 속한 유니크한 강의 객체 리스트
    * 4. basketMap: Key(walletId-lectureId-feeCode) -> 단일 장바구니 객체 (최하위 입력단)
        */
    const repMessage = JSON.parse(resp.repMessage)
    const data = JSON.parse(repMessage.voucherInfo)

    console.log('data=>', data)
    const maps = {
      voucher: data.voucher,
      studentMap: {},
      // students: data.students.slice(0, 10),
      students: data.students,
      wallets: data.wallets,
      planMap: {},
      plans: data.plans,
      walletMap: {},
      lectureMap: {},
      feeMap: {},
      basketMap: {},
      lecturesByWallet: {},
      plansByStudent: {},
      walletsByStudent: {},
      basketsByWallet: {},
      basketsByStudent: {},
      basketsByPlan: {},
      smstByPlan: {},
      voucherByStudent: {},
      feesbyLecture: {},
      lecturesByStudent: {},
      multiLecturesByStudent: {},
      walletsByPlan: {}
    }

    // 기초 정보 Map(Object) 생성 (ID 기반 단건 조회용)
    data.students.forEach(s => maps.studentMap[s.id] = s)
    data.plans.forEach(p => {
      maps.planMap[p.id] = p
      const smst = data.smsts.find(r => r.id === p.smstId)
      if (smst) {
        maps.smstByPlan[p.id] = smst
      }
    })
    data.lectures.forEach(l => maps.lectureMap[l.id] = l)
    data.wallets.forEach(w => maps.walletMap[`${w.studentId}-${w.planId}`] = w)
    data.fees.forEach(f => {
      maps.feeMap[`${f.lectureId}-${f.feeCode}`] = f
      if (!maps.feesbyLecture[f.lectureId]) maps.feesbyLecture[f.lectureId] = []
      maps.feesbyLecture[f.lectureId].push(f)
    })

    data.baskets.forEach(b => maps.basketMap[`${b.walletId}-${b.lectureId}-${b.feeCode}`] = b)
    data.voucherStudents.forEach(v => maps.voucherByStudent[v.studentId] = v)
    // 바스켓(Baskets) 데이터 사전 분류 (속도 향상을 위해 한 번만 순회)
    data.baskets.forEach(b => {
      // Wallet 기준 분류
      if (!maps.basketsByWallet[b.walletId]) maps.basketsByWallet[b.walletId] = []
      maps.basketsByWallet[b.walletId].push(b)

      // Wallet을 통해 Student 찾아서 분류
      const wallet = data.wallets.find(w => w.id === b.walletId)
      if (wallet) {
        if (!maps.basketsByStudent[wallet.studentId]) maps.basketsByStudent[wallet.studentId] = []
        maps.basketsByStudent[wallet.studentId].push(b)

        // LecturesByWallet 정리 (중복 제거 포함)
        if (!maps.lecturesByWallet[b.walletId]) maps.lecturesByWallet[b.walletId] = []
        const alreadyIn = maps.lecturesByWallet[b.walletId].some(l => l.id === b.lectureId)
        if (!alreadyIn) {
          const lecture = maps.lectureMap[b.lectureId]
          if (lecture) maps.lecturesByWallet[b.walletId].push(lecture)
        }

        //
        const plan = maps.planMap[wallet.planId]

        if (plan) {
          if (!maps.basketsByPlan[plan.id]) maps.basketsByPlan[plan.id] = []
          maps.basketsByPlan[plan.id].push(b)
        }
      }
    })

    // 월렛(Wallets) 기준 분류
    data.wallets.forEach(w => {
      // 학생별 월렛 목록
      if (!maps.walletsByStudent[w.studentId]) maps.walletsByStudent[w.studentId] = []
      maps.walletsByStudent[w.studentId].push(w)

      // 학생별 플랜 정보 (기존 로직 유지)
      if (!maps.plansByStudent[w.studentId]) maps.plansByStudent[w.studentId] = []
      const planInfo = maps.planMap[w.planId]
      if (planInfo) maps.plansByStudent[w.studentId].push({ ...planInfo, walletId: w.id })

      //
      if (!maps.walletsByPlan[w.planId]) maps.walletsByPlan[w.planId] = []
      maps.walletsByPlan[w.planId].push(w)
    })

    Object.values(maps.studentMap).forEach((student) => {
      // 학생 추가 정보
      const vs = maps.voucherByStudent[student.id]
      student.totalAmtUsed = vs.totalAmtUsed
      student.totalAmtRemain = vs.totalAmtRemain
      student.totalAmtBill = vs.totalAmtBill
      student.budget = vs.budget
      const baskets = maps.basketsByStudent[student.id]
      const totalAmtNeed = baskets?.map(b => b.amtFin).reduce((acc, cur) => acc + Number(cur), 0) || 0
      student.totalAmtNeed = totalAmtNeed

      // lecturesByStudent
      const uniqLectures = []
      const multiLectures = []

      const lecIdSet = new Set()
      data.plans.forEach((plan) => {
        const wallet = maps.walletMap[`${student.id}-${plan.id}`]
        if (wallet) {
          const lectures = maps.lecturesByWallet[wallet.id] || []
          lectures.forEach((lec) => {
            multiLectures.push(lec)

            if (!lecIdSet.has(lec.id)) {
              lecIdSet.add(lec.id)
              uniqLectures.push(lec)
            }
          })
        }
      })


      maps.lecturesByStudent[student.id] = uniqLectures
      maps.multiLecturesByStudent[student.id] = multiLectures

    })


    //
    const totalSummary = { budget: 0, totalAmtUsed: 0, totalAmtRemain: 0, totalAmtBill: 0 }
    const planSummary = {} // {planId: {amtUsed: 0, amtRemain: 0, amtBill: 0 } }
    maps.plans.forEach(plan => {
      planSummary[plan.id] = { amtUsed: 0, amtRemain: 0, amtBill: 0 }
    })

    Object.values(maps.studentMap).forEach((student) => {
      // 전체 합계 누적
      if (planViews._everyStudent === 'Y') {
        totalSummary.budget += (Number(student.budget) || 0)
        totalSummary.totalAmtUsed += (Number(student.totalAmtUsed) || 0)
        totalSummary.totalAmtRemain += (Number(student.totalAmtRemain) || 0)
        totalSummary.totalAmtBill += (Number(student.totalAmtBill) || 0)
      }
      else {
        const w = maps.walletsByStudent[student.id] || []
        if (w.length > 0) {
          totalSummary.budget += (Number(student.budget) || 0)
          totalSummary.totalAmtUsed += (Number(student.totalAmtUsed) || 0)
          totalSummary.totalAmtRemain += (Number(student.totalAmtRemain) || 0)
          totalSummary.totalAmtBill += (Number(student.totalAmtBill) || 0)
        }
      }


      // 차수(Plan)별 데이터 합산
      maps.plans.forEach(plan => {
        // 해당 학생의 해당 차수 지갑(Wallet) 정보 확인
        const wallet = maps.walletMap[`${student.id}-${plan.id}`]
        if (wallet) {
          planSummary[plan.id].amtUsed += (Number(wallet.amtUsed) || 0)
          planSummary[plan.id].amtRemain += (Number(wallet.amtRemain) || 0)
          planSummary[plan.id].amtBill += (Number(wallet.amtBill) || 0)
        }
      })
    })

    console.log('totalSummary=>', totalSummary)

    // 구조: {'planId': {'S002': 0, 'S003': 0 ... } }
    const feeSummaryByPlan = {}
    const amtFinSummaryByPlan = {}
    const amtFinSummaryByCode = {}
    feeCodes.forEach(f => {
      amtFinSummaryByCode[f.code] = 0
    })
    // 모든 차수에 대해 미리 초기값 0 세팅
    maps.plans.forEach(plan => {
      feeSummaryByPlan[plan.id] = {}
      amtFinSummaryByPlan[plan.id] = {}
      feeCodes.forEach(f => {
        feeSummaryByPlan[plan.id][f.code] = 0
        amtFinSummaryByPlan[plan.id][f.code] = 0
      })
    })

    // 전체 데이터 순회 및 합산
    Object.values(maps.studentMap).forEach((student) => {
      maps.plans.forEach(plan => {
        const wallet = maps.walletMap[`${student.id}-${plan.id}`]
        if (!wallet) return

        const lectures = maps.lecturesByWallet[wallet.id] || []
        lectures.forEach(lecture => {
          feeCodes.forEach(f => {
            const basket = maps.basketMap[`${wallet.id}-${lecture.id}-${f.code}`]
            if (basket) {
              // 해당 차수(plan.id)의 해당 항목(f.code)에 합산
              feeSummaryByPlan[plan.id][f.code] += (Number(basket.amt) || 0)
              amtFinSummaryByPlan[plan.id][f.code] += (Number(basket.amtFin) || 0)
              amtFinSummaryByCode[f.code] += (Number(basket.amtFin) || 0)
            }
          })
        })
      })
    })



    // 엑셀 결과 확인 (디버깅용)
    console.log('요금 항목별 총계:', feeSummaryByPlan)

    console.log('Optimized maps (Object) =>', maps)

    const newVoucherInfo = { ...data, maps, totalSummary, planSummary, feeSummaryByPlan, amtFinSummaryByPlan, amtFinSummaryByCode }
    if (!isSilent) {
      flushSync(() => {
        set_voucherInfo(newVoucherInfo)
      })
    }

    if (callback) {
      callback(newVoucherInfo)
    }

    return newVoucherInfo
  }

  // const fetchVoucherInfo = async () => {
  //   const url = `/voucher/info/${record.id}/${schola.id}`
  //   openIndicator()
  //   const resp = await WebService.get(url)
  //   closeIndicator()
  //   if (resp.repCode !== 'ack') {
  //     alert(resp.repMessage)
  //     return
  //   }

  //   parseVoucher(resp)

  // }

  useEffect(() => {
    const voucherId = voucherInfo?.voucher?.id
    if (!voucherId || !voucherInfo.plans) return

    const storageKey = `voucher_${voucherId}_plan_views`
    const saved = localStorage.getItem(storageKey)
    const savedViews = saved ? JSON.parse(saved) : {}

    const pv = {
      _direction: savedViews._direction || 'asc',
      _everyStudent: savedViews._everyStudent || 'N'
    }
    voucherInfo.plans.forEach(plan => {
      pv[plan.id] = savedViews[plan.id] || {
        shrink: false,
        hide: false,
      }
    })
    console.log('pv=>', pv)
    set_planViews(pv)
  }, [voucherInfo.voucher, voucherInfo.plans])

  useEffect(() => {
    const voucherId = voucherInfo?.voucher?.id
    if (!voucherId || Object.keys(planViews).length === 0) return

    const storageKey = `voucher_${voucherId}_plan_views`
    localStorage.setItem(storageKey, JSON.stringify(planViews))
  }, [planViews, voucherInfo.voucher])

  useEffect(() => {
    if (voucherInfo?.maps?.studentMap) {
      const totalSummary = calcTotalSummary(voucherInfo.maps)
      set_voucherInfo({ ...voucherInfo, totalSummary: totalSummary })
    }
  }, [planViews._everyStudent])

  const onLoad = async () => {
    await onInitWallet()
  }

  const fillFee = async (plan) => {

    const url = `/voucher/fill/fee/${plan.voucherId}/${plan.id}/${schola.id}`
    const data = {
      feeCodes: JSON.stringify(['S002', 'S003', 'S007'])
    }
    openIndicator()
    const resp = await WebService.post(url, data)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    parseVoucher(resp, false, (v) => {
      // originRef.current = JSON.parse(JSON.stringify(v))
      alert('요금채우기 후 저장버튼을 눌러야 서버에 반영되며 지원액과 징수액을 확인할 수 있습니다.')
    })

  }

  const onChangeClose = async (plan, closeYn) => {

    const url = `/voucher/change/close/plan/${plan.voucherId}/${plan.id}/${closeYn}/${schola.id}`
    openIndicator()
    const resp = await WebService.post(url)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const plans = JSON.parse(repMessage.plans)

    const planMap = {}
    plans.forEach(p => {
      planMap[p.id] = p
    })
    set_voucherInfo(prev => {
      return {
        ...prev,
        plans: plans,
        maps: { ...prev.maps, planMap: planMap }
      }
    })

    openSnackbar('변경되었습니다.')
  }



  const onChangeActive = async (plan, activeYn) => {
    const url = `/voucher/change/active/plan/${plan.voucherId}/${plan.id}/${activeYn}/${schola.id}`
    openIndicator()
    const resp = await WebService.post(url)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    const repMessage = JSON.parse(resp.repMessage)
    const plans = JSON.parse(repMessage.plans)


    const planMap = {}
    plans.forEach(p => {
      planMap[p.id] = p
    })
    set_voucherInfo(prev => {
      return {
        ...prev,
        plans: plans,
        maps: { ...prev.maps, planMap: planMap }
      }
    })
    // set_voucherInfo({...voucherInfo, plans: plans})
    openSnackbar('변경되었습니다.')
  }

  useEffect(() => {
    onLoad()
  }, [])

  useEffect(() => {
    const planWidth = (80 * 2) + 150 + (feeCodes.length * 80)
    const plans = voucherInfo?.maps?.plans
    if (plans) {
      const width = TOTAL_STICKY_WIDTH + plans.length * planWidth
      console.log('wdith=>', width)
      set_minWidth(width)

    }
  }, [voucherInfo])

  const VoucherButtons = ({ plan }) => {
    const plans = voucherInfo.plans
    const activePlan = plans.find(r => r.activeYn === 'Y')
    const activated = activePlan?.id === plan.id
    const baskets = voucherInfo.maps.basketsByPlan[plan.id]
    const basketSum = baskets?.map(r => r.amt).reduce((acc, cur) => acc + Number(cur), 0)
    const canActive = !activated && plan.closeYn === 'N' && !activePlan

    return (
      <>
        {

          canActive ? (
            <FlatButton variant='contained' sx={{ mr: 1, }}
              disabled={!canActive}
              onClick={() => {
                onChangeActive(plan, 'Y')
              }}
            >
              활성화
            </FlatButton>
          ) : activated ? (
            <FlatButton variant='contained' sx={{ mr: 1, }}
              onClick={() => {
                onChangeActive(plan, 'N')
              }}
            >
              비활성화
            </FlatButton>
          ) : (
            <FlatButton variant='contained' sx={{ mr: 1, }}
              disabled={true}
              onClick={() => {
                onChangeActive(plan, 'N')
              }}
            >
              비활성화
            </FlatButton>
          )
        }

        <FlatButton variant='contained' sx={{ mr: 1, }}
          disabled={!activated}
          onClick={() => {
            resetBaskets(plan.id)
          }}
        >
          요금초기화
        </FlatButton>
        <FlatButton variant='contained' sx={{ mr: 1, }}
          disabled={!activated}

          onClick={async () => {
            await fillFee(plan)
            // await onSaveBasket(voucherInfo.voucher.id, plan.id)
          }}
        >
          요금채우기
        </FlatButton>
        <FlatButton variant='contained' sx={{ mr: 1, }}
          disabled={!activated}
          onClick={() => {
            const wallets = voucherInfo.maps.walletsByPlan[plan.id]
            const amtUsed = wallets.map(r => r.amtUsed).reduce((acc, cur) => acc + Number(cur), 0) || 0
            const isSilent = amtUsed === 0 ? true : false
            const baskets = voucherInfo.maps.basketsByPlan[plan.id]
            onSaveBasket(baskets, voucherInfo.voucher.id, plan.id, isSilent)
          }}
        >
          저장
        </FlatButton>
        {/* <FlatButton variant='contained' sx={{ mr: 1, }}
          disabled={!activated}
          onClick={() => {
            xxx()
          }}
        >
          징수할당
        </FlatButton> */}
        {
          plan.closeYn === 'N' ? (
            <FlatButton variant='contained'
              disabled={!activated}
              onClick={async () => {
                const originBaskets = originRef.current.maps.basketsByPlan[plan.id]
                const curBaskkets = voucherInfo.maps.basketsByPlan[plan.id]

                const changedBaskets = curBaskkets.filter(cur => {
                  const origin = originBaskets.find(ori => ori.id === cur.id)
                  return !origin || cur.amt !== origin.amt || cur.amtFin !== origin.amtFin
                })
                if (changedBaskets.length > 0) {
                  alert('변경후 저장되지 않은 데이터가 있습니다. 마감하려면 저장 또는 다시 불러오기 후 해 주세요.')
                  return
                }
                await onChangeClose(plan, 'Y')
              }}
            >
              마감하기
            </FlatButton>
          ) : (
            <FlatButton variant='contained'
              onClick={async () => {
                await onChangeClose(plan, 'N')
              }}
            >
              마감취소
            </FlatButton>
          )
        }

      </>
    )
  }
  return (
    <Fragment>
      <div>
        {renderIndicator()}
        {renderAlert()}

      </div>
      <Dialog open={dialogHandler[0]} onClose={handleClose} fullScreen sx={{ backgroundColor: '#fff', }}>
        <DialogTitle>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs></Grid>
                <Grid item xs={10}>
                  <Box className={'center'}>
                    <Typography variant="h5" sx={{ margin: 1 }}>
                      {' '}
                      {schola.name}
                    </Typography>

                    <Typography variant="h5" sx={{ fontWeight: 'bold' }} align="center">
                      {record.name}
                    </Typography>
                    <Typography variant="h5" sx={{ margin: 1 }}>
                      바우처
                    </Typography>

                  </Box>
                </Grid>
                <Grid item xs style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                    <CloseIcon />
                  </IconButton>
                </Grid>

              </Grid>
            </Grid>

          </Grid>
        </DialogTitle>
        <DialogContent sx={{ maxHeight: '90vh', display: 'flex', flexDirection: 'column', flex: 1 }} >
          <FinEditor voucherInfo={voucherInfo} feeCodes={feeCodes} id={'finEditor'} onUpdateAmtFin={onUpdateAmtFin} />
          <BillViewer voucherInfo={voucherInfo} feeCodes={feeCodes} ref={billViewerRef} />

          <Box sx={{ display: 'flex', flexDirection: 'column', zIndex: 12, backgroundColor: '#fff' }}>
            <Grid container spacing={1}>


              <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                <Typography style={{ marginRight: 10, fontWeight: 'bold' }}>총 차수로 나누어 분할</Typography>
                {
                  feeCodes.map((f) => {
                    const checkedCodes = ['S002', 'S003', 'S007']
                    return (
                      <FormControlLabel

                        style={{ marginRight: 10 }}
                        control={
                          <Checkbox
                            defaultChecked={checkedCodes.includes(f.code)}
                            disabled={true}
                            color="primary"
                            onChange={async (e) => {
                            }}
                          />
                        }
                        label={f.name}
                      />
                    )

                  })
                }
              </Grid>
              {(() => {
                if (!voucherInfo.plans) {
                  return
                }

                const plans = voucherInfo?.plans
                const activePlans = plans?.filter(r => r.activeYn === 'Y')
                const closedPlans = plans?.filter(r => r.closeYn === 'Y')
                const wallets = voucherInfo?.wallets
                let advice = ''
                if (wallets?.length > 0) {
                  if (closedPlans?.length === plans.length) {
                    // no advice
                  }
                  else if (activePlans?.length === 0) {
                    advice = '활성화할 차수의 활성화 버튼을 클릭하면 요금 입력이 가능합니다.'
                  }
                }
                else {
                  advice = '바우처 설정에서 기수를 연결해야 바우처가 로우딩 됩니다.'
                }
                if (advice) {
                  return (
                    <Grid item xs={12}>
                      <Typography color={theme.palette.secondary.main}>{advice}</Typography>
                    </Grid>
                  )
                }

              })()}
              {
                voucherInfo.plans ? (
                  <Grid item xs={12}>
                    <Button
                      style={{ marginRight: 5 }}
                      startIcon={<ReplayOutlinedIcon />}
                      onClick={async () => {
                        await onReload()
                      }}
                    >다시불러오기</Button>
                    <Button
                      size="small"
                      style={{ marginRight: 5 }}
                      onClick={toggleDirection}
                      startIcon={planViews._direction === 'asc' ? <ArrowUpwardOutlinedIcon /> : <ArrowDownwardOutlinedIcon />}
                    >
                      {planViews._direction === 'asc' ? '시간순 ' : '시간역순'}
                    </Button>
                    <Button
                      style={{ marginRight: 5 }}
                      startIcon={<FileDownloadOutlinedIcon />}
                      onClick={() => {
                        handleDownload()
                      }}
                    >
                      다운로드
                    </Button>
                    <FormControlLabel

                      style={{ marginRight: 5, marginLeft: 10, }}
                      control={
                        <Checkbox
                          color="primary"
                          checked={planViews._everyStudent === 'N'}
                          onChange={(e) => {
                            // const f = e.target.checked ? 'Y' : N
                            toggleEveryStudent()
                          }}
                        />
                      }
                      label={'수강생만 보기'}
                    />
                  </Grid>
                ) : null
              }


            </Grid>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, mt: 2 }} key={counter}>
            <TableContainer
              component={Paper}
              sx={{
                maxWidth: '100%',
                overflow: 'auto',
              }}
            >
              <MUITable
                size="small"
                stickyHeader
                sx={{
                  // width: 'max-conttent',
                  width: 'auto',
                  // minWidth: '100%',
                  tableLayout: 'fixed',
                  borderCollapse: 'separate', // Sticky 작동을 위한 필수 설정
                  borderSpacing: 0            // separate 시 발생하는 간격 제거
                }}
              >
                <TableHead>
                  <TableRow>
                    <StickyTableCell
                      sx={{
                        left: 0,
                        zIndex: 12,
                        p: 0,
                        backgroundColor: '#f8f9fa',
                        borderRight: '2px solid #bbb',
                        width: TOTAL_STICKY_WIDTH,
                        minWidth: TOTAL_STICKY_WIDTH,
                        maxWidth: TOTAL_STICKY_WIDTH,
                        boxSizing: 'border-box',
                        overflow: 'hidden'
                      }}
                    >
                      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Box sx={mybox.top}>
                          <Box sx={{ ...mybox.base, ...mybox.grade }}>학년</Box>
                          <Box sx={{ ...mybox.base, ...mybox.className }}>반</Box>
                          <Box sx={{ ...mybox.base, ...mybox.classNum }}>번호</Box>
                          <Box sx={{ ...mybox.base, ...mybox.name }}>이름</Box>
                          <Box sx={{ ...mybox.base, ...mybox.budget }}>바우처액</Box>
                          <Box sx={{ ...mybox.base, ...mybox.amtRemain }}>잔액</Box>
                          <Box sx={{ ...mybox.base, ...mybox.amtUsed }}>총지원액</Box>
                          <Box sx={{ ...mybox.base, ...mybox.amtBill }}>총징수액</Box>
                        </Box>

                        {/* 하단 (Bottom Row) */}
                        {/* <Box sx={{ ...mybox.bottom, backgroundColor: '#fafafa' }}>
                          <Box sx={mybox.sublabel}>└ 징수금</Box>
                          <Box sx={{ ...mybox.base, ...mybox.fees }}>강사료</Box>
                          <Box sx={{ ...mybox.base, ...mybox.fees }}>수용비</Box>
                          <Box sx={{ ...mybox.base, ...mybox.fees }}>교재비</Box>
                          <Box sx={{ ...mybox.base, ...mybox.fees }}>재료비</Box>
                          <Box sx={{ ...mybox.base, ...mybox.fees }}>보조인건비</Box>
                          <Box sx={{ ...mybox.base, ...mybox.fees }}>기타비</Box>
                        </Box> */}
                      </Box>
                    </StickyTableCell>
                    {/* 차수별 헤더 영역 */}
                    {
                      (() => {
                        // const plans = voucherInfo?.maps?.plans

                        console.log('sortedPlans=>', sortedPlans)
                        return (
                          sortedPlans?.map((plan, idx) => {
                            let bgColor = '#eceff1'
                            if (plan?.activeYn === 'Y') {
                              bgColor = '#e3f2fd'
                            }
                            if (plan?.closeYn === 'Y') {
                              bgColor = '#e8f5e9'
                            }
                            // const bgColorr = plan?.activeYn === 'Y' ? '#e3f2fd' : '#eceff1'
                            // const bgColr = plan?.activeYn == 'Y' ? '#e1f5fe' : '#eceff1'
                            const smst = voucherInfo.maps.smstByPlan[plan.id]
                            if (idx < 0) {
                              return (
                                <TableCell
                                  key={`header-plan-id:${plan.id}`}
                                  align="center"
                                  sx={{
                                    borderRight: '2px solid #ccc', p: 0,
                                    width: 80 * 2 + 150 + (feeCodes.length * 80),
                                    // position: 'sticky', left: idx === 0 ? TOTAL_STICKY_WIDTH + 1 : null,
                                  }}
                                >
                                  {plan.id}
                                </TableCell>
                              )
                            }
                            else {
                              const isShrink = planViews[plan.id]?.shrink
                              return (
                                <TableCell
                                  key={`header-plan-id:${plan.id}`}
                                  align="center"
                                  sx={{
                                    borderRight: '2px solid #ccc', p: 0,
                                    width: planViews[plan.id]?.shrink ? (80 * 2) : (80 * 2) + 150 + (feeCodes.length * 80),
                                    // position: 'sticky', left: idx === 0 ? TOTAL_STICKY_WIDTH + 1 : null,
                                  }}
                                >
                                  <Box sx={{ p: 1, backgroundColor: bgColor, fontWeight: 'bold', borderBottom: '1px solid #e0e0e0' }}>
                                    <Grid container spacing={1} style={{ display: 'flex', alignItems: 'center' }}>
                                      <Grid item xs={2} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                        {
                                          !isShrink ? (
                                            <IconButton
                                              onClick={() => {
                                                console.log('plan=>', plan)
                                                planViews[plan.id].shrink = true
                                                set_planViews({ ...planViews })
                                              }}
                                            >
                                              <KeyboardArrowLeft />
                                            </IconButton>
                                          ) : (
                                            <IconButton
                                              style={{ marginRigh: 5 }}
                                              onClick={() => {
                                                console.log('plan=>', plan)
                                                planViews[plan.id].shrink = false
                                                set_planViews({ ...planViews })
                                              }}
                                            >

                                              <KeyboardArrowRight />
                                            </IconButton>
                                          )
                                        }

                                      </Grid>
                                      <Grid item xs={isShrink ? 8 : 3} >
                                        <Typography >{plan.chasu}차</Typography>
                                        {(() => {
                                          const str = isShrink
                                            ? `${smst?.year ?? ''}/${truncate(smst?.gisu ?? '', 4)}`
                                            : `${smst?.year ?? ''}/${smst?.gisu ?? ''}`
                                          return (
                                            <Typography >{str}</Typography>
                                          )
                                        })()}

                                      </Grid>
                                      {
                                        !isShrink && (
                                          <Grid item xs={7} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <VoucherButtons plan={plan} />
                                          </Grid>
                                        )
                                      }

                                    </Grid>

                                  </Box>
                                  <Box sx={{ display: 'flex', fontSize: '0.75rem', backgroundColor: '#fafafa' }}>
                                    <Box sx={{ width: 80, p: 0.5, borderRight: '1px solid #e0e0e0', flexShrink: 0 }}>지원액</Box>
                                    <Box sx={{ width: 80, p: 0.5, borderRight: '1px solid #e0e0e0', flexShrink: 0 }}>징수액</Box>
                                    {
                                      !isShrink && (
                                        <>
                                          <Box sx={{ width: 150, p: 0.5, borderRight: '1px solid #e0e0e0', flexShrink: 0 }}>강좌명</Box>
                                          {feeCodes.map(fc => (
                                            <Box key={fc.id} sx={{ width: 80, p: 0.5, borderRight: '1px solid #e0e0e0', flexShrink: 0 }}>{fc.name}</Box>
                                          ))}
                                        </>
                                      )
                                    }

                                  </Box>
                                </TableCell>
                              )
                            }
                          })
                        )

                      })()
                    }
                  </TableRow>
                </TableHead>

                <TableBody>
                  {
                    voucherInfo?.maps?.students?.map((student) => (
                      (() => {
                        const wallets = voucherInfo?.maps?.walletsByStudent[student.id]
                        const isEvery = planViews._everyStudent === 'Y'
                        const hasWallets = wallets?.length > 0
                        const render = isEvery || (!isEvery && hasWallets)
                        // 조건에 맞지 않으면 아무것도 렌더링하지 않음 (빈 Row 생성 방지)
                        if (!render) return null
                        return (
                          <StudentRow
                            key={`student-row-${student.id}`}
                            voucherInfo={voucherInfo}
                            student={student}
                            feeCodes={feeCodes}
                            planViews={planViews}
                            sortedPlans={sortedPlans}
                            priceEditorRef={priceEditorRef}
                            onUpdateBudget={onUpdateBudget}
                            billViewerRef={billViewerRef}
                          />
                        )
                      })()

                    ))
                  }

                </TableBody>
                <TableBody>
                  <SummaryRow voucherInfo={voucherInfo} feeCodes={feeCodes} planViews={planViews} sortedPlans={sortedPlans} />
                </TableBody>

              </MUITable>
            </TableContainer>
            <PriceEditor ref={priceEditorRef} />
          </Box>
        </DialogContent>
        <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
          <Button onClick={handleClose}>닫기</Button>
        </DialogActions>
      </Dialog>

    </Fragment>
  )
}

export default ManagerVoucherPartWall